import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class TrainingMaterialsService {

    constructor(private http: HttpClient) {}

    listFiles(): Observable<string[]> {
        return this.http.get<string[]>(
            `${environment.fileManagerBaseUrl}/api/training-materials/files`
        );
    }

    getDownloadUrl(fileName: string): string {
        return `${environment.fileManagerBaseUrl}/api/training-materials/files/${encodeURIComponent(fileName)}/download`;
    }

    downloadFile(fileName: string): Observable<HttpResponse<Blob>> {
        return this.http.get(
            `${environment.fileManagerBaseUrl}/api/training-materials/files/${encodeURIComponent(fileName)}/download`,
            {
                observe: 'response',
                responseType: 'blob'
            }
        );
    }
}
